import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { useTranslation, Trans } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import { RouteProfile } from 'routes'

const ReleaseSubscriptionLink = ({ updatingSubscription, subscribed, onClick, isEmailValid }) => {
  const { t } = useTranslation()
  const subscribeLabel = t('releaseNotesPage.subscribeRelease')
  const unsubscribeLabel = t('releaseNotesPage.unsubscribeRelease')

  return (
    <div>
      <div disabled data-tooltip-id='subscribe-tooltip-id'>
        <IconLink
          loading={updatingSubscription}
          active={subscribed}
          onClick={onClick}
          disabled={!isEmailValid}
          iconName='icon-subscribe'
          text={subscribed ? unsubscribeLabel : subscribeLabel}
        />
      </div>
      <Tooltip clickable hidden={isEmailValid} id='subscribe-tooltip-id' delayHide={500}>
        <p>
          <Trans i18nKey='ticketPage.subscribeLinkHint'>
            You are not able to subscribe, <Link to={RouteProfile()}>please update your email!</Link>
          </Trans>
        </p>
      </Tooltip>
    </div>
  )
}

ReleaseSubscriptionLink.propTypes = {
  updatingSubscription: PropTypes.bool.isRequired,
  subscribed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isEmailValid: PropTypes.bool,
}

export default ReleaseSubscriptionLink
